module.exports = __webpack_public_path__ + "img/34.68b11aee.png";